import {lazy} from "react";

import Routes from "Resources/Routes.json";

export default [
	{
		uri: Routes.account,
		auth: true,
		component: lazy(() => import("Profile/ProfileView.js")),
		inexact: true,
		title: "User Account",
		description: "Manage your membership."
	},
	{
		uri: "/news",
		auth: true,
		component: lazy(() => import("Profile/ProfileView.js")),
		inexact: true,
		title: "News",
		description: "View the latest Members' news."
	},
	{
		uri: Routes.basket,
		component: lazy(() => import("Checkout/BasketView.js")),
		title: "Basket"
	},
	{
		uri: Routes.checkout,
		component: lazy(() => import("Checkout/CheckoutView.js")),
		title: "Checkout"
	},
	{
		uri: Routes.cms,
		component: lazy(() => import("CMS/CMSView.js")),
		inexact: true,
		title: "Pages",
		description: "CMS pages"
	},
	{
		uri: Routes.faqs,
		component: lazy(() => import("FAQ/FaqView.js")),
		title: "FAQs",
		description: "Frequently asked questions."
	},
	{
		uri: Routes.donations,
		component: lazy(() => import("Donations/DonationsView.js")),
		inexact: true,
		feature: "Donations",
		title: "Donations",
		description: "Support our charitable aims."
	},
	{
		uri: `${Routes.memberships}/:membership/renew`,
		component: lazy(() => import("Memberships/MembershipsView.js")),
		auth: true,
		authHeader: "Membership Renewal",
		authCaption: "Please login to renew your membership.",
		feature: "Memberships",
		title: "Memberships",
		description: "Support us by becoming a member."
	},
	{
		uri: `${Routes.memberships}/:membership`,
		component: lazy(() => import("Memberships/MembershipsView.js")),
		feature: "Memberships",
		title: "Memberships",
		description: "Support us by becoming a member."
	},
	{
		uri: Routes.memberships,
		component: lazy(() => import("Memberships/MembershipsView.js")),
		feature: "Memberships",
		title: "Memberships",
		description: "Support us by becoming a member."
	},
	{
		uri: Routes.tickets,
		component: lazy(() => import("Tickets/TicketsView.js")),
		inexact: true,
		feature: "Tickets",
		title: "Tickets",
		description: "Purchase tickets for travel and special events."
	},
	{
		uri: Routes.shares,
		component: lazy(() => import("Shares/SharesView.js")),
		inexact: true,
		feature: "Shares",
		title: "Shares",
		description: "Purchase shares in a company."
	},
	{
		uri: Routes.shop,
		component: lazy(() => import("Shop/ShopView.js")),
		inexact: true,
		feature: "Shop",
		title: "Shop",
		description: "Purchase products."
	},
	{
		uri: Routes.preview,
		component: lazy(() => import("F12/PreviewModeView.js")),
		title: "Feature Management",
		description: "Manage available features in your session."
	},
	{
		uri: Routes.vouchers,
		component: lazy(() => import("Vouchers/VouchersView.js")),
		inexact: true,
		title: "Vouchers",
		description: "The perfect gift for a friend or family member."
	},
	{
		uri: Routes.giftcards,
		component: lazy(() => import("GiftCards/GiftCardsView.js")),
		inexact: true,
		title: "Gift Cards",
		description: "The perfect gift for a friend or family member."
	},
	{
		uri: "/pwr/:token",
		component: lazy(() => import("Login/PwrView.js")),
		publicOnly: true,
		title: "Password Reset",
		description: "Complete your password reset."
	},
	{
		uri: "/verify/email",
		component: lazy(() => import("Login/EmvView.js")),
		title: "Email Validation",
		description: "Validate an email address."
	},
	{
		uri: Routes.index,
		component: lazy(() => import("Index/IndexView.js")),
		index: true
	}
];
